<template>
<nav id="sidebar" class="sidebar sidebar-wrapper">
    <div class="sidebar-content">
        <h4 tabindex="0" class="text-white menu-header">Menú</h4>
        <div class="sidebar-brand"> </div>
        <div class="sidebar-menu">
            <ul id="js-navigation">
                <li class="sidebar-dropdown linkactivo border-top">
                    <router-link to="/" class="link itemNavContenido">Elementos de contextualización</router-link>
                </li>
                <li class="sidebar-dropdown">
                    <a href="#"> Contenido<span class="icon-siguiente flechamenu float-right cerrado " style="pointer-events: none;"></span> </a>
                    <div class="sidebar-submenu">
                        <ul>
                            <li class="sidebar-item">
                                <router-link to="/accionProblemica" class="link itemNavContenido">Acción problémica</router-link>
                            </li>
                            <li class="sidebar-item">
                                <router-link to="/conocimientosPrevios" class="link itemNavContenido">Conocimientos previos</router-link>
                            </li>
                            <li class="sidebar-item">
                                <router-link to="/Tema1" class="link itemNavContenido">Tema 1: Analogías entre figuras</router-link>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</nav>
</template>

<script>
//Importamos la funcion navigation 
import {
    Navigation
} from '../assets/RecursosITM/common/js/itm'

export default {
    name: 'Nav',
    mounted() {
        Navigation()
    }
}
</script>
